module.exports = __webpack_public_path__ + "static/media/dfs_logo.6ed3042e.svg";